<link href="https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600;700&display=swap" rel="stylesheet">
<div class="eesi-container">
  <div class="header">
    <div class="header-content">
      <div class="logo-section">
        <img [src]="logoPath" alt="Logo" class="logo">
      </div>
      
      <h1 class="headline">
        Partner with DBC1: Unlock <span class="highlight">30% Recurring Revenue</span> by Becoming an <strong>EESI Partner</strong> with <span class="highlight">Data Automation</span>
      </h1>
      <p class="subtitle">
        Transform one-time service work into a predictable software revenue stream as an Ecosystem Expert Partner.
      </p>
    </div>
  </div>

  <div class="content-wrapper">
    <section class="intro-section">
      <p class="section-label">For System Integrators and IT Consultants</p>
      <h2>Tired of Manual Data Sync Friction?</h2>
      <p class="intro-text">
        IT Consultants and System Integrators, are you tired of wasting high-value professional service hours on brittle, custom scripts for client email signature management? Manually synchronizing HRIS or CRM data to signatures is a non-recurring headache that devours your margins and client satisfaction.
      </p>
    </section>

    <section class="features-section">
      <div class="features-grid">
        <div class="feature-card">
          <div class="feature-icon">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"></path>
            </svg>
          </div>
          <h3>API-First Solution (REST API)</h3>
          <p>
            <strong>DBC1</strong> is the specialized, <strong>API-First</strong> platform that eliminates manual sync. Our robust <strong>REST API</strong> is the key to seamless, automated data flow from HRIS/CRM to the signature. Turn a one-time service headache into a predictable, recurring software sale.
          </p>
        </div>

        <div class="feature-card">
          <div class="feature-icon">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <h3>Guaranteed Server-Side Signatures</h3>
          <p>
            The power of <strong>Server-Side Signatures</strong> ensures flawless, brand-consistent deployment across your mid-market clients (100-500 users) in ecosystems like Salesforce, HubSpot, GWS, or M365. This means <strong>zero support burden</strong> for your team.
          </p>
        </div>

        <div class="feature-card">
          <div class="feature-icon">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V7a2 2 0 00-2-2H6a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
            </svg>
          </div>
          <h3>Advanced Analytics Module</h3>
          <p>
            Elevate your offering further: our <strong>Advanced Analytics Module</strong> empowers clients to use signatures for <strong>Marketing Attribution</strong>, transforming a utility into a measurable strategic asset. A new value-add your clients will love.
          </p>
        </div>
      </div>
    </section>

    <section class="cta-section">
      <div class="cta-card">
        <p class="cta-label">Your Partner Advantage</p>
        <h2>Earn a Massive <span class="highlight">30% Recurring Commission</span></h2>
        <p class="cta-text">
          Earn this commission on the customer subscription lifetime. We help you transition from non-recurring project work to predictable, high-margin software revenue.
        </p>
        <button (click)="scrollToForm()" class="cta-button">
          Apply for the EESI Partner Program Slot
        </button>
      </div>
    </section>

    <section id="partner-form" class="form-section">
      <h2>The EESI Partner Program</h2>
      <p class="form-subtitle">Limited partnership slots are available by a qualification call.</p>
      
      <form (ngSubmit)="onSubmit()" #applicationForm="ngForm" class="application-form">
        <div class="form-grid">
          <div class="input-group">
            <label for="company">Company Name</label>
            <input 
              type="text" 
              id="company" 
              name="company" 
              [(ngModel)]="application.company"
              required
              class="input-field"
            />
          </div>
          
          <div class="input-group">
            <label for="email">Contact Email</label>
            <input 
              type="email" 
              id="email" 
              name="email" 
              [(ngModel)]="application.email"
              required
              class="input-field"
            />
          </div>

          <div class="input-group full-width">
            <label for="systems">Primary Ecosystem Focus (e.g., Google Workspace, M365, Salesforce, HubSpot)</label>
            <input 
              type="text" 
              id="systems" 
              name="systems" 
              [(ngModel)]="application.systems"
              required
              class="input-field"
            />
          </div>
        </div>
        
        <button 
          type="submit" 
          class="submit-button"
          [disabled]="isSubmitting || !applicationForm.valid"
        >
          <span *ngIf="!isSubmitting && !submitted">Apply Now</span>
          <span *ngIf="isSubmitting">Sending...</span>
          <span *ngIf="submitted && !isSubmitting">Application Sent</span>
        </button>
      </form>
      
      <div *ngIf="submitted" class="success-message">
        Thank you! Your application has been submitted. We will be in touch shortly to schedule your discovery call.
      </div>
    </section>

    <footer class="footer">
      <p>&copy; {{ currentYear }} DBC1. All rights reserved.</p>
      <p class="footer-subtitle">API-First Data Automation for Ecosystem Experts.</p>
    </footer>
  </div>
</div>
